export default function DownloadSection() {
  return (
    <section id="download" className="w-full py-16 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-4">
              随时随地，<span className="text-primary-500">小蓝视频</span>伴你左右
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-8 max-w-lg">
              下载小蓝视频APP，享受更流畅的观看体验。支持离线下载，地铁通勤、旅行路上，精彩内容永不下线。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#"
                className="flex items-center gap-3 px-6 py-3 bg-foreground-900 text-background-50 rounded-lg whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors duration-200"
              >
                <i className="ri-apple-fill text-2xl"></i>
                <div className="text-left">
                  <div className="text-xs text-background-400">Download on the</div>
                  <div className="text-sm font-semibold">App Store</div>
                </div>
              </a>
              <a
                href="#"
                className="flex items-center gap-3 px-6 py-3 bg-foreground-900 text-background-50 rounded-lg whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors duration-200"
              >
                <i className="ri-google-play-fill text-2xl"></i>
                <div className="text-left">
                  <div className="text-xs text-background-400">GET IT ON</div>
                  <div className="text-sm font-semibold">Google Play</div>
                </div>
              </a>
            </div>

            <div className="mt-8 flex items-center justify-center lg:justify-start gap-6 text-sm text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                完全免费
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                无广告干扰
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                高清画质
              </span>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="relative w-64 h-[460px] rounded-3xl overflow-hidden border-4 border-foreground-900 shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20Chinese%20short%20video%20app%20interface%20mockup%20on%20a%20smartphone%20screen%2C%20clean%20minimalist%20UI%20design%2C%20video%20feed%20layout%2C%20warm%20color%20scheme%2C%20youthful%20and%20trendy%20design%2C%20dark%20phone%20frame%2C%20isolated%20on%20transparent%20background&width=600&height=1200&seq=app-mockup-2026&orientation=portrait"
                alt="小蓝视频APP界面"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}